import { prefersReducedMotion } from './utils.js';

/**
 * Initialize Lenis smooth scroll.
 * Loaded as a global (assets/lenis.min.js) so we access window.Lenis.
 * Syncs with GSAP ticker if ScrollTrigger is present.
 */
export function initLenis() {
  if (prefersReducedMotion()) return;
  if (typeof window.Lenis === 'undefined') {
    console.warn('[KW] Lenis not found — smooth scroll disabled.');
    return;
  }

  const lenis = new window.Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
    smoothTouch: false,
    touchMultiplier: 2,
  });

  window.lenis = lenis;

  /* Sync GSAP ScrollTrigger scroll position with Lenis */
  if (window.gsap && window.ScrollTrigger) {
    lenis.on('scroll', window.ScrollTrigger.update);
    window.gsap.ticker.add((time) => lenis.raf(time * 1000));
    window.gsap.ticker.lagSmoothing(0);
  } else {
    /* Fallback RAF loop when GSAP is not available */
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }
}
